import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Quiz = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState('');
  const [quizQuestions, setQuizQuestions] = useState([]);

  // Pool of 50 questions
  const questionPool = [
    // Stock Market Fundamentals
    {
      question: "What is a stock?",
      options: [
        "A loan to a company",
        "A share of ownership in a company",
        "A type of bond",
        "A savings account"
      ],
      correct: 1
    },
    {
      question: "What does market capitalization refer to?",
      options: [
        "The total value of a company's outstanding shares",
        "The maximum amount a stock can increase in one day",
        "The total debt of a company",
        "The number of employees in a company"
      ],
      correct: 0
    },
    {
      question: "What is an IPO?",
      options: [
        "International Payment Option",
        "Investor Protection Organization",
        "Initial Public Offering",
        "Institutional Purchase Order"
      ],
      correct: 2
    },
    {
      question: "Which stock exchange is known for listing technology companies?",
      options: [
        "NYSE",
        "NASDAQ",
        "LSE",
        "TSE"
      ],
      correct: 1
    },
    {
      question: "What is a bear market?",
      options: [
        "A market where prices are falling",
        "A market where prices are rising",
        "A market that's closed",
        "A market for commodities"
      ],
      correct: 0
    },
    {
      question: "What is a bull market?",
      options: [
        "A market where prices are falling",
        "A market where prices are rising",
        "A market that's closed",
        "A market for livestock"
      ],
      correct: 1
    },
    {
      question: "Companies with a market cap over $10 billion are classified as:",
      options: [
        "Small-cap",
        "Mid-cap",
        "Large-cap",
        "Mega-cap"
      ],
      correct: 2
    },
    {
      question: "What typically happens to a company's stock price when it announces better-than-expected earnings?",
      options: [
        "It usually falls",
        "It usually rises",
        "It remains unchanged",
        "It gets suspended from trading"
      ],
      correct: 1
    },
    {
      question: "What is the S&P 500?",
      options: [
        "A stock trading at $500 per share",
        "An index of 500 large U.S. companies",
        "A tax form for investors",
        "A type of retirement account"
      ],
      correct: 1
    },
    {
      question: "What happens during a stock split?",
      options: [
        "The company divides into two separate companies",
        "The number of shares increases while the price per share decreases proportionally",
        "The company buys back shares from investors",
        "The stock is removed from its exchange"
      ],
      correct: 1
    },
    
    // Investment Basics
    {
      question: "What does diversification mean?",
      options: [
        "Putting all money in one stock",
        "Spreading investments across different assets",
        "Only buying expensive stocks",
        "Trading frequently"
      ],
      correct: 1
    },
    {
      question: "What is an ETF?",
      options: [
        "Electronic Trading Fund",
        "Exchange-Traded Fund",
        "Equity Trust Factor",
        "Extended Tax Form"
      ],
      correct: 1
    },
    {
      question: "What is dollar-cost averaging?",
      options: [
        "Converting investments from foreign currencies to dollars",
        "Investing a fixed amount at regular intervals regardless of price",
        "Buying stocks only when the dollar is strong",
        "Calculating the average cost of all your investments in dollars"
      ],
      correct: 1
    },
    {
      question: "Which account type offers tax-free growth and withdrawals in retirement?",
      options: [
        "Traditional IRA",
        "401(k)",
        "Roth IRA",
        "Standard brokerage account"
      ],
      correct: 2
    },
    {
      question: "What is compound interest often called?",
      options: [
        "The investor's enemy",
        "The eighth wonder of the world",
        "The market maker",
        "The risk reducer"
      ],
      correct: 1
    },
    {
      question: "What does the expense ratio of a fund represent?",
      options: [
        "The percentage of your investment that goes to fees annually",
        "The ratio of stocks to bonds in the fund",
        "The percentage of companies in the fund that are profitable",
        "The fund's performance compared to its benchmark"
      ],
      correct: 0
    },
    {
      question: "What is asset allocation?",
      options: [
        "Distributing assets to family members",
        "Dividing investments among different asset classes like stocks and bonds",
        "Allocating money to different brokers",
        "Assigning different assets to different financial goals"
      ],
      correct: 1
    },
    {
      question: "What does ESG investing focus on?",
      options: [
        "Eastern and Southern Global markets",
        "Extremely Stable Growth companies",
        "Environmental, Social, and Governance factors",
        "Equity, Securities, and Guarantees"
      ],
      correct: 2
    },
    {
      question: "What is the Rule of 72 used for?",
      options: [
        "Calculating tax deductions",
        "Estimating how long it takes for an investment to double",
        "Determining the maximum portfolio allocation for one stock",
        "Setting the retirement age"
      ],
      correct: 1
    },
    {
      question: "Which of these is generally considered the safest investment?",
      options: [
        "Small-cap stocks",
        "Cryptocurrency",
        "U.S. Treasury bonds",
        "Penny stocks"
      ],
      correct: 2
    },
    
    // Trading Principles
    {
      question: "What is a limit order?",
      options: [
        "An order to buy or sell a security at the current market price",
        "An order to buy or sell a security at a specific price or better",
        "An order that limits the number of shares you can buy",
        "An order that expires at the end of the trading day"
      ],
      correct: 1
    },
    {
      question: "What is a stop-loss order designed to do?",
      options: [
        "Guarantee profits on a trade",
        "Prevent buying overpriced stocks",
        "Limit potential losses on a position",
        "Stop trading for the day after a loss"
      ],
      correct: 2
    },
    {
      question: "What trading timeframe involves opening and closing positions within the same day?",
      options: [
        "Swing trading",
        "Position trading",
        "Day trading",
        "Scalping"
      ],
      correct: 2
    },
    {
      question: "What does FOMO stand for in trading psychology?",
      options: [
        "Focus On Market Opportunities",
        "Fear Of Missing Out",
        "Finding Optimal Market Openings",
        "Fundamental Oversight of Market Operations"
      ],
      correct: 1
    },
    {
      question: "What is the risk-to-reward ratio used for?",
      options: [
        "Calculating taxes on trading profits",
        "Measuring a broker's performance",
        "Evaluating whether a trade is worth taking",
        "Determining market volatility"
      ],
      correct: 2
    },
    {
      question: "What does high trading volume typically indicate?",
      options: [
        "Low interest in a security",
        "Significant interest and liquidity in a security",
        "The market is closed",
        "The stock will definitely increase in value"
      ],
      correct: 1
    },
    {
      question: "What is the bid-ask spread?",
      options: [
        "The difference between a stock's highest and lowest price for the day",
        "The difference between the highest price a buyer is willing to pay and the lowest price a seller is willing to accept",
        "The spread of investment across different sectors",
        "The difference between a company's revenue and expenses"
      ],
      correct: 1
    },
    {
      question: "Which of these is NOT a common chart pattern in technical analysis?",
      options: [
        "Head and shoulders",
        "Double top",
        "Financial pyramid",
        "Cup and handle"
      ],
      correct: 2
    },
    {
      question: "What is scalping in trading?",
      options: [
        "Buying tickets to resell at higher prices",
        "Making trades that last seconds to minutes to profit from small price changes",
        "Analyzing company financial statements",
        "Reducing position size after losses"
      ],
      correct: 1
    },
    {
      question: "What does a trailing stop do?",
      options: [
        "Follows behind market trends",
        "Moves up as the price of the security increases",
        "Stops trading after a certain profit percentage",
        "Trails the performance of a benchmark index"
      ],
      correct: 1
    },
    
    // Risk Management
    {
      question: "What is systematic risk?",
      options: [
        "Risk that affects a specific company",
        "Risk that affects the entire market",
        "Risk that can be completely eliminated",
        "Risk that only affects systematic traders"
      ],
      correct: 1
    },
    {
      question: "What is the primary purpose of diversification?",
      options: [
        "To maximize returns",
        "To reduce risk",
        "To eliminate taxes",
        "To increase dividend income"
      ],
      correct: 1
    },
    {
      question: "What is position sizing?",
      options: [
        "The physical size of a trading desk",
        "Determining how much of your portfolio to allocate to each investment",
        "The number of positions you hold",
        "The size of a company's market position"
      ],
      correct: 1
    },
    {
      question: "What does a correlation coefficient of -1.0 between two assets indicate?",
      options: [
        "They move in the same direction",
        "They move in opposite directions",
        "They have no relationship",
        "One asset will always outperform the other"
      ],
      correct: 1
    },
    {
      question: "What is hedging in investment terms?",
      options: [
        "Trimming bushes around your property",
        "Avoiding making investment decisions",
        "Taking offsetting positions to reduce risk exposure",
        "Investing only in hedge funds"
      ],
      correct: 2
    },
    {
      question: "What is the Kelly Criterion used for?",
      options: [
        "Selecting stocks based on value",
        "Determining optimal position size",
        "Calculating tax liability",
        "Measuring market volatility"
      ],
      correct: 1
    },
    {
      question: "What is stress testing a portfolio?",
      options: [
        "Checking if your investments cause you stress",
        "Simulating how your portfolio would perform under adverse scenarios",
        "Testing new investment strategies",
        "Analyzing past performance during stressful market periods"
      ],
      correct: 1
    },
    {
      question: "Which of these is an example of a defensive asset?",
      options: [
        "Small-cap technology stocks",
        "Cryptocurrency",
        "Treasury bonds",
        "Leveraged ETFs"
      ],
      correct: 2
    },
    {
      question: "What is liquidity risk?",
      options: [
        "The risk of investing in water utilities",
        "The risk of not being able to sell an investment quickly without a loss",
        "The risk of having too much cash in your portfolio",
        "The risk of a company running out of cash"
      ],
      correct: 1
    },
    {
      question: "What is the primary purpose of a stop-loss order?",
      options: [
        "To guarantee profits",
        "To limit potential losses",
        "To increase trading volume",
        "To avoid taxes on gains"
      ],
      correct: 1
    },
    
    // Market Analysis
    {
      question: "What does P/E ratio stand for?",
      options: [
        "Price to Earnings",
        "Profit to Expense",
        "Performance to Expectation",
        "Potential to Earnings"
      ],
      correct: 0
    },
    {
      question: "What is the RSI indicator used for?",
      options: [
        "Measuring company revenue",
        "Identifying overbought or oversold conditions",
        "Calculating dividend yields",
        "Determining market capitalization"
      ],
      correct: 1
    },
    {
      question: "What is the VIX often called?",
      options: [
        "Victory Index",
        "Volatility Indicator X",
        "Fear Index",
        "Value Investment Xchange"
      ],
      correct: 2
    },
    {
      question: "What does a yield curve inversion historically signal?",
      options: [
        "Bull market ahead",
        "Potential recession ahead",
        "Stable interest rates",
        "Increased dividend payments"
      ],
      correct: 1
    },
    {
      question: "Which is a leading economic indicator?",
      options: [
        "Unemployment rate",
        "GDP",
        "Building permits",
        "Corporate profits"
      ],
      correct: 2
    },
    {
      question: "What sector typically outperforms during the early recovery phase of the economic cycle?",
      options: [
        "Utilities",
        "Consumer Staples",
        "Consumer Discretionary",
        "Healthcare"
      ],
      correct: 2
    },
    {
      question: "What is fundamental analysis primarily concerned with?",
      options: [
        "Chart patterns and price movements",
        "Market sentiment and psychology",
        "A company's intrinsic value based on financial statements and economic factors",
        "Trading volume and liquidity"
      ],
      correct: 2
    },
    {
      question: "What is a golden cross in technical analysis?",
      options: [
        "A religious symbol used by traders",
        "When a short-term moving average crosses above a long-term moving average",
        "The intersection of support and resistance lines",
        "The highest point a stock reaches before declining"
      ],
      correct: 1
    },
    {
      question: "What does MACD stand for?",
      options: [
        "Multiple Average Calculation Derivative",
        "Market Analysis and Chart Direction",
        "Moving Average Convergence Divergence",
        "Maximum Achievable Capital Distribution"
      ],
      correct: 2
    },
    {
      question: "What is quantitative analysis in investing?",
      options: [
        "Analyzing the quantity of shares traded",
        "Using mathematical and statistical methods to evaluate investments",
        "Counting the number of analysts covering a stock",
        "Measuring the quantity of a company's products sold"
      ],
      correct: 1
    }
  ];

  // Select 5 random questions when component mounts
  useEffect(() => {
    const getRandomQuestions = () => {
      const shuffled = [...questionPool].sort(() => 0.5 - Math.random());
      return shuffled.slice(0, 5);
    };
    
    setQuizQuestions(getRandomQuestions());
  }, []);

  const handleAnswerClick = (selectedOption) => {
    setSelectedAnswer(selectedOption);
  };

  const handleNextQuestion = () => {
    if (selectedAnswer === quizQuestions[currentQuestion].correct) {
      setScore(score + 1);
    }

    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < quizQuestions.length) {
      setCurrentQuestion(nextQuestion);
      setSelectedAnswer('');
    } else {
      setShowScore(true);
    }
  };

  const resetQuiz = () => {
    // Get a new set of random questions
    const shuffled = [...questionPool].sort(() => 0.5 - Math.random());
    setQuizQuestions(shuffled.slice(0, 5));
    
    setCurrentQuestion(0);
    setScore(0);
    setShowScore(false);
    setSelectedAnswer('');
  };

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-8 mx-auto">
          <h1 className="mb-4">🧠 Knowledge Quiz</h1>
          
          {showScore ? (
            <div className="quiz-card text-center">
              <h3>Quiz Complete!</h3>
              <p className="lead">
                You scored {score} out of {quizQuestions.length}
              </p>
              <div className="progress-bar-custom mb-3">
                <div 
                  className="progress-fill" 
                  style={{ width: `${(score / quizQuestions.length) * 100}%` }}
                ></div>
              </div>
              <p>
                {score === quizQuestions.length 
                  ? "Perfect! You're ready to start investing!" 
                  : score >= quizQuestions.length / 2 
                  ? "Good job! Review the topics you missed." 
                  : "Keep studying! Review the educational content."}
              </p>
              <button className="btn btn-primary-custom" onClick={resetQuiz}>
                Take Quiz Again
              </button>
            </div>
          ) : (
            <div className="quiz-card">
              {quizQuestions.length > 0 ? (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="badge bg-primary">
                      Question {currentQuestion + 1} of {quizQuestions.length}
                    </span>
                    <div className="progress-bar-custom" style={{ width: '200px' }}>
                      <div 
                        className="progress-fill" 
                        style={{ width: `${((currentQuestion + 1) / quizQuestions.length) * 100}%` }}
                      ></div>
                    </div>
                  </div>
                  
                  <h4 className="mb-4">{quizQuestions[currentQuestion].question}</h4>
                  
                  <div className="d-grid gap-2">
                    {quizQuestions[currentQuestion].options.map((option, index) => (
                      <button
                        key={index}
                        className={`btn ${selectedAnswer === index ? 'btn-primary' : 'btn-outline-secondary'} text-start`}
                        onClick={() => handleAnswerClick(index)}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </>
              ) : (
                <p>Loading questions...</p>
              )}
              
              <div className="text-center mt-4">
                <button 
                  className="btn btn-primary-custom"
                  onClick={handleNextQuestion}
                  disabled={selectedAnswer === ''}
                >
                  {currentQuestion === quizQuestions.length - 1 ? 'Finish Quiz' : 'Next Question'}
                </button>
              </div>
            </div>
          )}
          
          <div className="text-center mt-4">
            <Link to="/" className="btn btn-outline-custom">
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quiz;
